// Generated by GitHub Copilot
import React, { createContext, useContext, useState } from "react";

/**
 * NavActiveSectionContext
 *
 * Lets a route-level page (the "publisher", e.g. ModernIncidentDetailPage)
 * tell the persistent ModernHeader nav (the "consumer") which top-level
 * section the currently-viewed content belongs to, so the correct nav tab
 * highlights even on a route that does not match either NavLink's `to`.
 *
 * `section` ∈ {'current', 'past', null}:
 *   - 'current' → highlight "Current Status"
 *   - 'past'    → highlight "Past Incidents"
 *   - null      → highlight NEITHER (let NavLink's URL-based active state stand)
 *
 * This is a VISUAL-ONLY signal (Decision A): the consumer applies the active
 * CSS class but emits NO aria-current on the detail route. Real route matches
 * on / and /past-incidents still get NavLink's built-in aria-current="page".
 */
const NavActiveSectionContext = createContext({
  section: null,
  setSection: () => {},
});

/**
 * Provider holding the active-section state. Wrap the layout so that both the
 * header (consumer) and the route children (publisher) share one instance.
 */
export const NavActiveSectionProvider = ({ children }) => {
  const [section, setSection] = useState(null);

  return (
    <NavActiveSectionContext.Provider value={{ section, setSection }}>
      {children}
    </NavActiveSectionContext.Provider>
  );
};

/**
 * Hook for publishers (route pages). Returns the stable setter so a page can
 * declare which section it belongs to (or null to clear).
 * @returns {Function} setSection('current' | 'past' | null)
 */
export const useSetNavActiveSection = () => {
  const { setSection } = useContext(NavActiveSectionContext);
  return setSection;
};

/**
 * Hook for the consumer (ModernHeader). Returns the current section.
 * @returns {{ section: ('current' | 'past' | null) }}
 */
export const useNavActiveSection = () => {
  const { section } = useContext(NavActiveSectionContext);
  return { section };
};

export default NavActiveSectionContext;
